import React from 'react';

import Breadcrumbs from '../../molecules/Breadcrumbs';
import Badge from '../../molecules/Badge';

import { color } from '../../atoms/colors';
import {
  Section,
  Wrapper,
  Container,
  Categories,
  Button,
} from './styles/HeroLearningDetail.styled';

const LearningDetailHero = ({ component }) => (
  <Section id="heroComponent">
    <Wrapper>
      <Breadcrumbs theme="dark" />
      <Container>
        <Categories>
          {component?.categories?.map(cat => {
            const queryParam = cat?.safeName
              ?.replace('&', 'and')
              .split(' ')
              .join('-');

            return (
              <Button
                onClick={() => navigate(`/learning?category=${queryParam}`)}
                key={cat?.id}
              >
                <Badge
                  label={cat?.name}
                  backgroundColor={color.green[50]}
                  textColor={color.green[900]}
                  style={{ borderRadius: '4px' }}
                />
              </Button>
            );
          })}
        </Categories>
        <h1 className="heading">{component?.internalName}</h1>
      </Container>
    </Wrapper>
  </Section>
);

export default LearningDetailHero;
